import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import BASE_URL from '../../config';

const initialState = {
  profiles: [],
  referencePrice: null,
  status: 'idle',
  error: null,
};

export const fetchCalculatorRates = createAsyncThunk(
  'calculator/fetchRates',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}/calculator/v1/rates/`);
      if (!response.ok) return rejectWithValue(await response.json());
      return response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchReferencePrice = createAsyncThunk(
  'calculator/fetchReferencePrice',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}/calculator/v1/reference-price/`);
      if (!response.ok) return rejectWithValue(await response.json());
      return response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const calculatorSlice = createSlice({
  name: 'calculator',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCalculatorRates.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchCalculatorRates.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.profiles = action.payload.profiles;
      })
      .addCase(fetchCalculatorRates.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(fetchReferencePrice.fulfilled, (state, action) => {
        state.referencePrice = action.payload;
      });
  },
});

export default calculatorSlice.reducer;
